export default __webpack_public_path__ + "static/media/arrow-down-icon.5c651de8.svg";